import SEOHead from "@/components/base/SEOHead";
import SchemaOrg from "@/components/base/SchemaOrg";
import Breadcrumb from "@/components/base/Breadcrumb";
import { aboutData } from "@/mocks/homeData";

export default function AboutPage() {
  const { brand, reputation, contact } = aboutData;

  const breadcrumbItems = [
    { label: "首页", href: "/" },
    { label: "关于我们" },
  ];

  return (
    <>
      <SEOHead
        title="关于我们 - 必赢亚洲"
        description="必赢亚洲成立于2015年，是亚洲领先的在线娱乐游戏平台。了解必赢亚洲品牌介绍、信誉口碑和联系方式。"
        keywords="必赢亚洲官网,关于必赢亚洲,必赢亚洲品牌,必赢亚洲联系方式,必赢亚洲信誉"
        canonicalUrl="https://www.biyingyazhou.com/about"
      />
      <SchemaOrg
        data={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "关于我们 - 必赢亚洲",
          "description": "了解必赢亚洲品牌介绍、信誉口碑和联系方式",
          "url": "https://www.biyingyazhou.com/about",
          "inLanguage": "zh-CN",
          "about": {
            "@type": "Organization",
            "name": "必赢亚洲",
            "foundingDate": "2015",
            "description": "亚洲领先的在线娱乐游戏平台",
          },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.biyingyazhou.com/" },
              { "@type": "ListItem", "position": 2, "name": "关于我们" },
            ],
          },
        }}
      />

      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
            <Breadcrumb items={breadcrumbItems} />
          </div>
        </div>

        <div className="relative h-56 md:h-72 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20luxurious%20modern%20office%20building%20exterior%20at%20sunset%20with%20golden%20warm%20lighting%2C%20elegant%20architecture%20with%20glass%20facade%2C%20professional%20corporate%20headquarters%20atmosphere%2C%20dramatic%20sky%20with%20golden%20clouds%2C%20premium%20corporate%20photography%20style%20with%20sophisticated%20composition&width=1600&height=600&seq=about-hero-001&orientation=landscape"
            alt="必赢亚洲品牌"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/70"></div>
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
            <div className="max-w-7xl mx-auto">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-background-50">
                关于必赢亚洲
              </h1>
              <p className="mt-2 text-background-300 text-base">
                亚洲顶级娱乐游戏平台，值得信赖的品牌
              </p>
            </div>
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                  {brand.title}
                </h2>
                {brand.content.map((paragraph, idx) => (
                  <p key={idx} className="text-sm text-foreground-700 leading-relaxed mb-4">
                    {paragraph}
                  </p>
                ))}
              </div>
              <div className="grid grid-cols-2 gap-4">
                {brand.highlights.map((item, idx) => (
                  <div
                    key={idx}
                    className="bg-background-100 rounded-lg p-5 border border-background-200/70 text-center"
                  >
                    <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                      {item.value}
                    </div>
                    <div className="text-xs text-foreground-600 mt-1">{item.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div className="order-2 lg:order-1">
                <div className="relative h-64 md:h-80 rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20prestigious%20award%20ceremony%20scene%20with%20golden%20trophies%20and%20certificates%20on%20elegant%20display%2C%20dark%20luxurious%20background%20with%20warm%20golden%20spotlight%2C%20professional%20awards%20photography%20with%20sophisticated%20atmosphere%2C%20premium%20and%20prestigious%20composition&width=800&height=600&seq=about-reputation-001&orientation=landscape"
                    alt="必赢亚洲信誉口碑"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="order-1 lg:order-2">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                  {reputation.title}
                </h2>
                {reputation.content.map((paragraph, idx) => (
                  <p key={idx} className="text-sm text-foreground-700 leading-relaxed mb-4">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section id="contact" className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                {contact.title}
              </h2>
              <p className="mt-3 text-foreground-600 text-sm">
                如有任何疑问，欢迎通过以下方式联系我们
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-4xl mx-auto">
              <div className="bg-background-100 rounded-lg p-5 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-xs text-foreground-600">{contact.email}</p>
              </div>

              <div className="bg-background-100 rounded-lg p-5 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 mb-3">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">客服电话</h3>
                <p className="text-xs text-foreground-600">{contact.phone}</p>
              </div>

              <div className="bg-background-100 rounded-lg p-5 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 mb-3">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">微信客服</h3>
                <p className="text-xs text-foreground-600">{contact.wechat}</p>
              </div>

              <div className="bg-background-100 rounded-lg p-5 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 mb-3">
                  <i className="ri-time-line text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">服务时间</h3>
                <p className="text-xs text-foreground-600">{contact.workingHours}</p>
              </div>
            </div>

            <div className="mt-8 max-w-md mx-auto bg-background-100 rounded-lg p-5 border border-background-200/70 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 mb-3">
                <i className="ri-map-pin-line text-xl"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">公司地址</h3>
              <p className="text-xs text-foreground-600">{contact.address}</p>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}